import { render, staticRenderFns } from "./VideoInfoTabs.vue?vue&type=template&id=3cb8d32a&scoped=true"
import script from "./VideoInfoTabs.vue?vue&type=script&lang=js"
export * from "./VideoInfoTabs.vue?vue&type=script&lang=js"
import style0 from "./VideoInfoTabs.vue?vue&type=style&index=0&id=3cb8d32a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb8d32a",
  null
  
)

export default component.exports